import React, { useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";
import useScrollView from "../userScrollView";
import { useContext } from "react";
import { amitContext } from "../../context/amit";

function About() {

  const ref = useRef()
  const {current} = useContext(amitContext)
  useEffect(() => {
    if(current === 'skills')
    ref?.current?.scrollIntoView({})

  }, [current])



  return (
    <Container fluid className="about-section" ref={ref} >
      <Particle />
      <Container>
        <h1 className="project-heading">
          Professional <strong className="purple">Skillset </strong>
        </h1>

        <Techstack />

        <h1 className="project-heading">
          <strong className="purple">Tools</strong> I use
        </h1>
        <Toolstack />

        <Github />
      </Container>
    </Container>
  );
}

export default About;
